<template>
  <header>
    <Container indent="wide">
      <Breadcrumbs class="mb-10 lg:mb-7" />
      <h1 class="mb-4 max-w-title text-4xl font-medium sm:text-6xl">
        <span v-html="$replaceHtmlTags(data.heading)" />
        <span v-if="data.workload"> ({{ data.workload }})</span>
      </h1>
      <NuxtLink
        v-if="data.company_link"
        class="mb-5 inline-block max-w-text text-lg font-medium text-blue-800 transition-colors hover:text-blue-dark"
        :to="useFormatUrlWithHttps(data.company_link)"
        :target="$useTarget(data.company_link)"
      >
        {{ data.company_title }}
      </NuxtLink>

      <p class="mb-11 text-sm opacity-60 sm:text-base">
        {{ $t('advertisement_dated') }} {{ date }}
      </p>

      <JobMetaTiles :page="data" class="mb-11 flex flex-wrap gap-3 xl:hidden" />

      <div
        v-if="data.lead"
        class="mb-11 max-w-text text-md font-medium sm:text-lg"
        v-html="data.lead"
      />
      <div v-if="data.text" class="max-w-text" v-html="data.text" />
    </Container>
  </header>
</template>

<script setup>
const props = defineProps({
  data: { type: Object, required: true },
})

const date = computed(() => {
  if (!props.data?.created_at) {
    return null
  }

  return new Date(props.data.created_at).toLocaleDateString('de', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  })
})
</script>
